module.exports = __webpack_public_path__ + "static/media/close.0e9dd49c.svg";